export enum LanguageActions {
  UPDATE_SYSTEM_LANGUAGE_ACTION = "UPDATE_SYSTEM_LANGUAGE_ACTION",
  LOAD_SYSTEM_LANGUAGE_ACTION = "LOAD_SYSTEM_LANGUAGE_ACTION",
}